import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { RewardRate } from 'components/rewards/RewardRateDisplay'
import { formatCurrency } from 'toolbox/format'
import DataPoint, { DataPointProps } from 'components/common/DataPoint'
import { useAppDispatch } from 'state/hooks'
import { UnclaimedBanner } from 'components/rewards/UnclaimedBanner'
import { ClaimRewards } from 'components/rewards/ClaimRewards'

export function Rewards() {
  const { connected, account } = useWallet()
  const dispatch = useAppDispatch()

  // Mock data for rewards - in a real implementation, this would come from state/API
  const mockRewardsData = {
    supplyRewards: [
      { poolAsset: 'USDC', rewardAsset: 'MOVE', unclaimedTokens: 120.5, unclaimedUSD: 21 },
      { poolAsset: 'WETH', rewardAsset: 'MOVE', unclaimedTokens: 134, unclaimedUSD: 23.75 }
    ],
    borrowRewards: [
      { poolAsset: 'WBTC', rewardAsset: 'MOVE', unclaimedTokens: 52.77, unclaimedUSD: 9.5 }
    ]
  }

  const totalUnclaimedTokens =
    mockRewardsData.supplyRewards.reduce((total, reward) => total + reward.unclaimedTokens, 0) +
    mockRewardsData.borrowRewards.reduce((total, reward) => total + reward.unclaimedTokens, 0)
  const totalUnclaimedUSD =
    mockRewardsData.supplyRewards.reduce((total, reward) => total + reward.unclaimedUSD, 0) +
    mockRewardsData.borrowRewards.reduce((total, reward) => total + reward.unclaimedUSD, 0)

  const handleClaimRewards = () => {
    // TODO: Implement actual claim functionality
    console.log('Claiming rewards:', totalUnclaimedTokens)
  }

  return (
    <div className="rewards">
      <h1>Mock Rewards</h1>

      <UnclaimedBanner
        totalUnclaimedTokens={totalUnclaimedTokens}
        totalUnclaimedUSD={totalUnclaimedUSD}
      />

      {totalUnclaimedTokens > 0 && (
        <ClaimRewards
          totalClaimAmount={totalUnclaimedTokens}
          supplyRewards={mockRewardsData.supplyRewards}
          borrowRewards={mockRewardsData.borrowRewards}
          onClaim={handleClaimRewards}
          disabled={false}
        />
      )}

      {/* Rewards Info */}
      <div className="rewards-info">
        <h2>How Rewards Work</h2>
        <div className="info-grid">
          <div className="info-item">
            <h3>Supply Rewards</h3>
            <p>
              Earn MOVE tokens by supplying assets to incentivized pools. Rewards are distributed
              weekly based on your position size and duration.
            </p>
          </div>
          <div className="info-item">
            <h3>Borrow Rewards</h3>
            <p>
              Earn rewards for borrowing certain assets. These rewards can help offset borrowing
              costs and increase your overall yield.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
